import { ChangeEvent, Dispatch, SetStateAction } from "react";

import RenderNewUploadingImagesList from "@app/components/RenderNewUploadingImagesList";
import { useRenderFileViewHook } from "@app/hooks/imagesRender";
import { useFormContext } from "react-hook-form";
import { ApiEndpoint, extendedFileFormats } from "@constants/index";
import { Button, Typography } from "@mui/material";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import COLORS from "@app/colors";

import { CreateRecipeState, ICreateRecipeFormData } from "@pages/RecipeMutation/helper/types";
import { IFlowProcess } from "@pages/RecipeMutation/useCreateRecipeLogic";
import { VisuallyHiddenInput } from "./styled";

interface ProductImageProps {
  setFlowProcess: Dispatch<SetStateAction<IFlowProcess>>;
  onChangeSingleUpload: (event: ChangeEvent<HTMLInputElement>, index: number | null) => void;
}

const ProductImage = ({
  setFlowProcess,
  onChangeSingleUpload
}: ProductImageProps) => {
  const { watch, formState: { errors } } = useFormContext<ICreateRecipeFormData>()
  const image = watch('uploadedFiles')
  const isUploadedImage = image && 'url' in image
  const existingImages = watch('existingImages')

  const previews = useRenderFileViewHook(image, existingImages)

  return (
    <>
      <RenderNewUploadingImagesList<CreateRecipeState>
        setState={setFlowProcess}
        newPreviewsList={isUploadedImage ? [`${ApiEndpoint}/${image.url}`] : previews}
        togetherImagesLength={isUploadedImage ? 1 : previews.length}
      />
      <Button
        sx={{ maxWidth: '200px' }}
        component="label"
        role={undefined}
        variant="contained"
        tabIndex={-1}
        startIcon={<CloudUploadIcon />}
      >
        <p>{ image ? 'Edit Image' : 'Upload Pictures' }</p>
        <VisuallyHiddenInput
          type="file"
          id="files"
          name="images"
          accept={extendedFileFormats.join(',')}
          onChange={(e) => onChangeSingleUpload(e, null)}
        />
      </Button>
      <Typography color={COLORS.red}>
        {errors.images?.message}
      </Typography>
    </>
  );
}

export default ProductImage;
